module.exports = __webpack_public_path__ + "static/media/pizza.b6a74bc5.png";